<template>
  <div id="messengers">
    <div class="w-full px-4 pb-6 mx-auto md:px-10">
      <div class="max-w-md px-4 md:mx-0">
        <div id="leelooai_form" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Messengers",

  mounted() {
    if (!document.getElementById("leelooai_script")) {
      this.initLeelooAiWidget();
    }
  },

  beforeDestroy() {
    this.clearForm();
  },

  methods: {
    initLeelooAiWidget() {
      window.LEELOO_INIT = { id: "5dfa09d126f856000d86128b" };
      const script = document.createElement("script");
      script.onload = this.setForm();
      script.id = "leelooai_script";
      script.src = "https://app.leeloo.ai/init.js";
      script.async = true;
      document.head.appendChild(script);
    },
    setForm() {
      window.LEELOO_LEADGENTOOLS = (window.LEELOO_LEADGENTOOLS || []).concat(
        "vbi4op"
      );
    },
    clearForm() {
      let script = document.getElementById("leelooai_script");
      if (script) script.remove();
      window.LEELOO_INIT_CHECK = false;
      window.LEELOO_LEADGENTOOLS = [];
    }
  }
};
</script>
